var _path, _path2, _path3, _path4, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoybean = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V10",
    stroke: "#558B2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12 14 16 13 17 10C17.5 8.5 16 7 14 8C12 9 12 11 12 14Z",
    fill: "#6B8E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12 14 8 13 7 10C6.5 8.5 8 7 10 8C12 9 12 11 12 14Z",
    fill: "#6B8E23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 9 14.5 7 14.5 4.5C14.5 3 13 2 12 3C11 2 9.5 3 9.5 4.5C9.5 7 12 9 12 9Z",
    fill: "#6B8E23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 17,
    r: 1.2,
    fill: "#6B8E23"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18.5,
    r: 1,
    fill: "#6B8E23"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoybean);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/soybean.e50bab215f744960e14174fb16ee7a70.svg";